function setupSliders() {
  document.querySelectorAll('.js-image-slider').forEach((slider) => {
    let slideIndex = 0;
    const slides = slider.querySelectorAll('.js-image-slider-slide');

    function changeSlide() {
      slides[slideIndex].classList.remove('show');
      slideIndex = (slideIndex + 1) % slides.length;
      slides[slideIndex].classList.add('show');
    }

    function autoSlide() {
      changeSlide();
      setTimeout(autoSlide, 3000);
    }

    setTimeout(autoSlide, 3000);
  });
}

document.addEventListener('DOMContentLoaded', setupSliders);